import React, { useContext, useEffect, useState } from 'react';
import { get as lodashGet } from 'lodash';
import moment from 'moment-timezone';
import { momentTimeFormater, timeOnly } from '../../../utils/dateHelper';
import classes from '../Home.module.css';
import { AuthContext } from '../../../context/AuthContext';
import { useLoader } from '../../../hooks/use-loader.hook';
import { FrequencyService } from '../../../services/FrequencyService';
import { usToEuCurrencyFormat } from '../../../utils/currencyHelper';
import EChart from '../../../components/Echarts/Echarts';

const getFrequencySignalData = (customer, value) => {
    const { frequency = [] } = customer;
    const data = frequency.find((f) => f._id === value);
    return data;
};

const getFrequencyAnnotaions = (frequencyGraphProperties) => {
    return [
        {
            enabled: frequencyGraphProperties?.enableLineMin,
            value: frequencyGraphProperties?.lineMin,
            color: '#219e4d',
        },
        {
            enabled: frequencyGraphProperties?.enableLineMax,
            value: frequencyGraphProperties?.lineMax,
            color: '#775DD0',
        },
    ]
        .filter((item) => item.enabled)
        .map((item) => ({
            yAxis: item.value,
            lineStyle: {
                color: item.color,
                type: 'dashed',
            },
            label: {
                formatter: item.value,
                color: '#fff',
                backgroundColor: item.color,
            },
        }));
};

const FrequencyCard = () => {
    const { state } = useContext(AuthContext);
    const [startLoader, stopLoader] = useLoader();
    const [data, setData] = useState([]);
    const e3DashboardConfig = lodashGet(state, 'user.customerId.e3DashboardConfig');
    const frequencyGraphProperties = lodashGet(state, 'user.customerId.properties');
    const frequencySignalData = getFrequencySignalData(lodashGet(state, 'user.customerId'), e3DashboardConfig.r1c1.value);
    const frequencyAnnotations = getFrequencyAnnotaions(frequencyGraphProperties);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        if (e3DashboardConfig?.r1c1?.value) {
            const curCetDateTime = moment().tz('Europe/Berlin');
            const params = {
                date: momentTimeFormater(curCetDateTime).format('YYYY-MM-DD'),
                end: curCetDateTime.format('HH:mm'),
                start: curCetDateTime.subtract(30, 'minutes').format('HH:mm'),
            };
            FrequencyService.getFrequencyData(e3DashboardConfig.r1c1.value, params, startLoader, handleSuccess, handleError, stopLoader);
        }
    };

    const handleSuccess = ({ data }) => setData(data.data.graph);

    const handleError = (error) => {
        console.error(error);
    };

    const formatYAxisValue = (value) => {
        return usToEuCurrencyFormat(value, 3);
    };

    return (
        <div className={classes.TopGraph} style={{ flexGrow: 1 }}>
            <EChart
                series={data}
                title="Frequency (Hz)"
                xFormatter={timeOnly}
                yFormatter={formatYAxisValue}
                type="line"
                yAxisProps={{
                    ...(frequencyGraphProperties?.lowVisible && { min: frequencyGraphProperties.lowVisible }),
                    ...(frequencyGraphProperties?.highVisible && { max: frequencyGraphProperties.highVisible }),
                }}
                annotations={frequencyAnnotations}
                rightSideElement={<strong>{frequencySignalData.name}</strong>}
                zoomOnMouseWheel={false}
                yTooltipSuffix={['Hz']}
            />
        </div>
    );
};

export default FrequencyCard;
